import { notifications } from "@mantine/notifications"
import { AxiosError } from "axios"

import { queryClient } from "~/backend/queryClient"
import {
  findSupplierMappingQueryKey,
  useDeleteSupplierMapping,
} from "~/gen/api/hooks"

export const useDeleteSupplierMappingMutation = ({
  searchSupplier,
}: {
  searchSupplier: string
}) =>
  useDeleteSupplierMapping({
    mutation: {
      onSuccess: async () => {
        notifications.show({
          title: "Supplier deleted",
          message: `Supplier deleted successfully`,
          color: "teal",
        })
        await queryClient.invalidateQueries(
          findSupplierMappingQueryKey({
            searchSupplier,
          })
        )
      },
      onError: (error) => {
        if (error instanceof AxiosError) {
          notifications.show({
            title: "Supplier delete error",
            message: "Supplier delete failed : " + error.response?.data,
            color: "red",
          })
        }
      },
    },
  })
